import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { waterSources } from '../DataSets';

const WaterSource = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="waterSource"
      name="waterSource"
      items={waterSources}
      label="Water Source"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select water source"
    />
  );
};

export default WaterSource;
